import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export const RemoveTrailingSlash = () => {
  const location = useLocation();
  // Check if the pathname contains a repetitive slashes
  if (/\/{2,}/.test(location.pathname)) {
    // Remove all repetitive slashes in pathname
    return (
      <Redirect
        to={{
          ...location,
          pathname: location.pathname.replace(/\/{2,}/g, '/'),
        }}
      />
    );
  }
  return null;
};
